(function () {
  function moveIndicator(rail, indicator, tab) {
    if (!rail || !indicator || !tab) return;
    var railRect = rail.getBoundingClientRect();
    var tabRect = tab.getBoundingClientRect();
    var inset = tabRect.left - railRect.left;
    indicator.style.width = tabRect.width + 'px';
    indicator.style.transform = 'translateX(' + inset + 'px)';
  }

  function initWarrantyPolicy(root) {
    var rail = root.querySelector('.hmc-warranty-tabs__rail');
    var indicator = root.querySelector('.hmc-warranty-tabs__indicator');
    var tabs = Array.prototype.slice.call(
      root.querySelectorAll('.hmc-warranty-tabs__tab[data-hmc-warranty-tab]')
    );
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-hmc-warranty-panel]'));
    if (!tabs.length || !rail) return;

    function activate(id) {
      var activeTab = null;

      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-hmc-warranty-tab') === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on) activeTab = tab;
      });

      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-hmc-warranty-panel') === id;
        panel.hidden = !on;
        panel.classList.toggle('is-active', on);
      });

      moveIndicator(rail, indicator, activeTab);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-hmc-warranty-tab'));
      });

      tab.addEventListener('keydown', function (event) {
        var idx = tabs.indexOf(tab);
        var next = null;
        if (event.key === 'ArrowRight') next = tabs[idx + 1];
        if (event.key === 'ArrowLeft') next = tabs[idx - 1];
        if (!next) return;
        event.preventDefault();
        next.focus();
        activate(next.getAttribute('data-hmc-warranty-tab'));
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var active = tabs.find(function (t) {
          return t.classList.contains('is-active');
        });
        moveIndicator(rail, indicator, active);
      }, 100);
    });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        var active = tabs.find(function (t) {
          return t.classList.contains('is-active');
        });
        moveIndicator(rail, indicator, active);
      });
      ro.observe(rail);
    }

    requestAnimationFrame(function () {
      activate('after');
    });
  }

  function boot() {
    document.querySelectorAll('[data-hmc-warranty-policy]').forEach(initWarrantyPolicy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
